import { supabase } from '../supabaseClient';

async function getAllTokens() {
    let query = supabase.from('Tokens').select('*', { count: 'exact' })
    const { data, error, count } = await query;
    if (data) return { data, count };
    else throw error;
}
//Refund token
async function tokenRefundRequest(loggedInUserId,paymentId,reason,status) {
    const { data, error } =
        await supabase.from('TokenRefundRequests').insert([
            {
                userId:loggedInUserId,
                lastUpdatedBy:loggedInUserId,
                paymentId:paymentId,
                reason:reason,
                status:status
            }])
    if (data) return data;
    else throw error;
}


async function getAllTokenFromServer(from , to , search , drpDownSelectedVal , selectedTokenType , selectedRefundable , selectedTokenValidity) {
    const TokenFilters = {
        'Name Ascending': {
          key: 'name',
          isAscending: true,
        },
        'Name Descending': {
          key: 'name',
          isAscending: false,
        },
        'Oldest First': {
          key: 'created_at',
          isAscending: true,
        },
        'Latest First': {
          key: 'created_at',
          isAscending: false,
        },
      };

      var query ;
      query = supabase.from('Tokens')
      .select('*', { count: 'exact' })
      .order(TokenFilters[drpDownSelectedVal].key, {
        ascending: TokenFilters[drpDownSelectedVal].isAscending,
      })
      .range(from , to);

      if(search !== null || search !== '' || search !== undefined) {
        search = search.replace(/\s\s+/g, ' ')
        query = query.ilike('name', `%${search}%`);
      }

      if(selectedTokenType.length === 1) {
        console.log(selectedTokenType)
          if(selectedTokenType.includes('None')) {
            query = query.eq('isPriorityPass' , false).eq('isPreselect' , false)
          }
        if(selectedTokenType.includes('Priority Pass')) {
            query = query.eq('isPriorityPass' , true)
        }

        if(selectedTokenType.includes('Preselect')) {
            query = query.eq('isPreselect' , true)
        }

      }

      if(selectedTokenType.length === 2) {
        if(selectedTokenType.includes("Preselect") && selectedTokenType.includes("Priority Pass")) {
            query = query.eq('isPriorityPass' , true).eq('isPreselect' , true)
        }

        if(selectedTokenType.includes('None') && selectedTokenType.includes('Preselect')) {
          query = query.eq('isPriorityPass' , false)
        }

        if(selectedTokenType.includes('None') && selectedTokenType.includes('Priority Pass')) {
          query = query.eq('isPreselect' , false)
        }
      }

      if(selectedRefundable.length === 1) {
        console.log(selectedRefundable)
        
        if(selectedRefundable[0] === 'Yes') {
            query = query.eq('isRefundable' , true)
        }

        if(selectedRefundable[0] === 'No') {
            query = query.eq('isRefundable' , false)
        }
      }

      if(selectedTokenValidity.length !== 0) {
        console.log(selectedTokenValidity)
        query = query.in('validity' , selectedTokenValidity)
      }

      const { data, count, error } = await query
      if (data) return { data, count };
      else throw error;
    }    

//get token

export { getAllTokens,tokenRefundRequest , getAllTokenFromServer }